module.exports = __webpack_public_path__ + "static/media/Assigned.29f62c75.svg";